<template>
  <div>
    <div
      align="right"
      class="error-message"
    >
      {{ noMetricsError }}
    </div>
    <div
      class="slide-out-metrics-tab"
      :class="noMetricsClass">
      <div class="options">
        <Checkbox
          v-for="metric in activeMetrics"
          v-model="metric.checked"
          class="option"
          :key="metric.key"
          :name="metric.value"
          @input="handleSelect(metric, $event)"
        >
          {{ metric.key }}
        </Checkbox>
      </div>
      <div v-if="inactiveMetrics.length > 0" class="inactive-heading">
        Not Available with Current Parameters
      </div>
      <div class="options">
        <Checkbox
          v-for="metric in inactiveMetrics"
          v-model="metric.checked"
          class="option"
          :key="metric.key"
          :name="metric.value"
          :disabled="true"
        >
          {{ metric.key }}
        </Checkbox>
      </div>
    </div>
  </div>
</template>
<script>
import { Checkbox } from '@mikmak/components';

export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  components: {
    Checkbox,
  },
  data() {
    return {
      metrics: this.value,
      missingMetricsMessage: 'You must select a metric',
    };
  },
  computed: {
    activeMetrics() {
      return this.metrics.filter(m => !m.disabled);
    },
    inactiveMetrics() {
      return this.metrics.filter(m => m.disabled);
    },
    noMetrics() {
      return this.metrics.every(m => !m.checked);
    },
    noMetricsClass() {
      return this.noMetrics ? 'error' : '';
    },
    noMetricsError() {
      return this.noMetrics ? this.missingMetricsMessage : '';
    },
  },
  methods: {
    handleSelect(metric, val) {
      const selectedMetric = this.metrics.find(m => m.key === metric.key);

      selectedMetric.checked = val;
      this.$emit('updateMetrics');
    },
  },
  watch: {
    value(val) {
      this.metrics = val;
    },
  },
};
</script>
<style lang="scss" scoped>
.slide-out-metrics-tab {
  font-family: Lato;
  color: #223448;
  border: 1.5px solid #C1CCD4;
  border-radius: 4px;
  max-height: 555px;
  padding-bottom: 20px;
}
.slide-out-metrics-tab.error {
  border: 1.5px solid #CB4444;
}
.error-message {
  color: #9A2F35;
  font-family: Lato;
  font-size: 12px;
  height: 16px;
  width: 100%;
  margin-right: 8px;
}
.options-menu {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-weight: bold;
  font-size: 16px;
  line-height: 140%;
  color: #4369F4;
  padding: 10px 12px;
  div {
    cursor: pointer;
  }
}
.label,
.option {
  padding: 14px 15px 4px 15px;
}
.label {
  font-weight: bold;
}
.inactive-heading {
  font-family: Lato;
  font-weight: 700;
  font-size: 16px;
  color: #2C3F58;
  margin: 24px 12px 10px 12px;

}
</style>
